import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { updateTotalSessions } from "../services/update-total-sessions";

export function useUpdateTotalSessions() {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({
      usage_id,
      new_total_session_quantity,
    }: {
      usage_id: string;
      new_total_session_quantity: number;
    }) => updateTotalSessions(usage_id, new_total_session_quantity),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"], exact: false });
      toast({
        title: "Success",
        description: "Total session count updated",
      });
    },

    onError: (error: any) => {
      toast({
        title: "Error",
        description: error?.message || "Failed to update total session count",
        variant: "destructive",
      });
    },
  });
}
